/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { SportPersonRunFastIcon16Light } from './SportPersonRunFastIcon16Light';
import { SportPersonRunFastIcon16Regular } from './SportPersonRunFastIcon16Regular';
import { SportPersonRunFastIcon16Solid } from './SportPersonRunFastIcon16Solid';
import { SportPersonRunFastIcon20Light } from './SportPersonRunFastIcon20Light';
import { SportPersonRunFastIcon20Regular } from './SportPersonRunFastIcon20Regular';
import { SportPersonRunFastIcon20Solid } from './SportPersonRunFastIcon20Solid';
import { SportPersonRunFastIcon24Regular } from './SportPersonRunFastIcon24Regular';
import { SportPersonRunFastIcon24Solid } from './SportPersonRunFastIcon24Solid';
import { SportPersonRunFastIcon32Regular } from './SportPersonRunFastIcon32Regular';
import { SportPersonRunFastIcon64Regular } from './SportPersonRunFastIcon64Regular';
var sizes = {
    16: {
        light: SportPersonRunFastIcon16Light,
        regular: SportPersonRunFastIcon16Regular,
        solid: SportPersonRunFastIcon16Solid,
    },
    20: {
        light: SportPersonRunFastIcon20Light,
        regular: SportPersonRunFastIcon20Regular,
        solid: SportPersonRunFastIcon20Solid,
    },
    24: {
        regular: SportPersonRunFastIcon24Regular,
        solid: SportPersonRunFastIcon24Solid,
    },
    32: {
        regular: SportPersonRunFastIcon32Regular,
    },
    64: {
        regular: SportPersonRunFastIcon64Regular,
    },
};
export var SportPersonRunFastIcon = forwardRef('SportPersonRunFastIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
